import React, { useRef } from "react";

// Components
import FormValidation from "pages/ticketing/components/FormValidation";
import LoadingSpinner from "components/LoadingSpinner";

const PaymentEvidenceForm = ({
  handleOpenUploadForm,
  show,
  handleInputChange,
  userForm,
  loading,
}) => {
  const fileInputRef = useRef(null);

  const handleChangeDocument = () => {
    fileInputRef.current.click();
  };

  if (!show) return null;

  return (
    <div className="text-justify">
      <h3 className="mb-6 text-xl font-semibold leading-snug">
        Ready to make your mark? <br />
        Finalize your registration.
      </h3>
      <p className="mb-3 text-sm leading-relaxed text-gray-700">
        Complete the final step of your registration by submitting your
        registration number and payment evidence.
      </p>
      <p className="mb-3 text-sm leading-relaxed text-gray-700">
        A confirmation email will be sent once your payment has been verified.
      </p>

      <div className="mb-4">
        <label className="block text-sm font-semibold">
          Registration Number<span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          name="registrationNumber"
          placeholder="Enter your registration number (SBMS-XXX)"
          className="w-full mt-1 border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-[#93C047] focus:outline-none"
          onChange={(e) => handleInputChange(e.target.name, e.target.value)}
          value={userForm.registrationNumber}
        />
        <FormValidation
          value={userForm.registrationNumber}
          showError={!userForm.validRegistrationNumber}
        />
      </div>

      <div className="mb-4">
        <div>
          <label className="block mb-1 text-sm font-semibold">
            Upload Payment Evidence<span className="text-red-500">*</span>
          </label>

          <div className="relative flex items-center justify-center w-full border-2 border-gray-300 border-dashed rounded-lg h-24 cursor-pointer hover:border-[#E78D41] transition">
            <input
              ref={fileInputRef}
              type="file"
              name="paymentEvidenceDocument"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              accept="image/png,image/jpeg,image/jpg"
              onChange={(e) =>
                handleInputChange(e.target.name, e.target.files, true)
              }
            />

            {userForm?.paymentEvidenceDocument ? (
              <div
                className="flex flex-col items-center justify-center ml-5 mr-5 pointer-events-none"
                onClick={handleChangeDocument}
              >
                <div className="text-sm text-center">
                  {userForm.paymentEvidenceDocument.name}
                </div>
                <span className="mt-2 text-sm text-gray-400">
                  Change Document
                </span>
              </div>
            ) : (
              <div className="text-center">
                <div className="text-gray-400 pointer-events-none">
                  Upload Here
                </div>
                <div className="mt-2 text-xs text-gray-400 pointer-events-none">
                  Max file size 10 Mb & Only accept file image
                </div>
              </div>
            )}
          </div>
          <FormValidation
            value={userForm.paymentEvidenceDocument}
            showError={
              !userForm.validPaymentEvidenceDocument ||
              !userForm.validPaymentEvidenceDocumentFileSize ||
              !userForm.validPaymentEvidenceDocumentFileType
            }
            errorMsg={
              !userForm.validPaymentEvidenceDocumentFileSize
                ? "File is too large! Max size is 10MB."
                : !userForm.validPaymentEvidenceDocumentFileType
                  ? "Only .png or .jpg or .jpeg image files are allowed."
                  : ""
            }
          />
        </div>
      </div>

      <div className="flex justify-end pt-2">
        <div
          className="px-5 py-2 rounded-md bg-[#F58220] text-white hover:bg-[#D67E32] transition text-sm font-medium cursor-pointer"
          onClick={() =>
            handleOpenUploadForm({
              firstForm: false,
              secondForm: false,
              downloadForm: false,
              paymentEvidenceForm: true,
            })
          }
        >
          {loading ? <LoadingSpinner isLoading={loading} /> : "Submit"}
        </div>
      </div>
    </div>
  );
};

export default PaymentEvidenceForm;
